import { CsvFormatAndColumns } from "../csv/DetectCsvFormat";
import { parseCsv } from "../csv/PapaParsing";
import { DataArray } from "../data/DataChunk";
import { parseColumns } from "./ParseColumns";

export function parseDsvText(text: string, csvParams: CsvFormatAndColumns): DataArray[] {
  const rowTable = parseCsv(text, csvParams.format);
  return parseColumns(rowTable, csvParams.columns);
}
